/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Prompt_Placeholder_DraftInputs */



/**
* | output |
* | --- |
* | "Need something drafted, checked or explained?" |
*
* @param {Chat_Prompt_Placeholder_DraftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_prompt_placeholder_draft = /** @type {((inputs?: Chat_Prompt_Placeholder_DraftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Prompt_Placeholder_DraftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Soll ich etwas entwerfen, prüfen oder erklären?")
	return /** @type {LocalizedString} */ ("Need something drafted, checked or explained?")
});